module.exports = __webpack_public_path__ + "static/img/zhihui.3c9dfe8d.png";